import * as React from "react";
import * as cn from "classnames";

export interface IconByUrlComponentProps {
    className: string;
    imageUrl: string;
}

export const IconByUrlComponent = (props: IconByUrlComponentProps) => (
    <span
        className={cn("common-icon", props.className)}
        style={{
            backgroundImage: "url('" + props.imageUrl + "')"
        }}
    />
);
